module.exports = __webpack_public_path__ + "static/media/shaff1137.a794b954.jpg";